import { createSelector } from 'reselect';

import { getCurrentLeg } from './screen';
import { sortAirportServices } from '../service/sort';

export const getCurrentAirportServices = createSelector(
    (state) => state.airportServices,
    getCurrentLeg,
    (airportServices, leg) => {
        if (!airportServices || !leg || !airportServices[leg.id]) return {};

        const airportTakeOff = leg.airportTakeOff ?? {};
        const airportLanding = leg.airportLanding ?? {};

        return Object.values(airportServices[leg.id])
            .sort(sortAirportServices)
            .reduce((res, item) => {
                const airport = item.planFlightAirportID === leg.id ? airportTakeOff : airportLanding;
                const isTakeOff = item.planFlightAirportID === leg.id;
                ((res[airport.code] ||= { name: airport.name, nameEng: airport.nameEng, services: [], isTakeOff }).services ||= []).push(
                    item
                );

                return res;
            }, {});
    }
);
